import { Component, OnInit } from '@angular/core';
import { AcordoService, DevedorService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DetalheBaseController } from '../../helpers';
import { EmailService } from 'app/services/email.service';
import { LogSistemaService } from '../../services/logSistema.service';

@Component({
    templateUrl: 'portal.component.html'
})

export class PortalComponent extends DetalheBaseController{
       
    boletoId: String = "";        
    subDevedor: Subscription;              
    dividas: any = [];
    _currentUser: any;     
    subDividas: Subscription;    
    
    constructor(private router: Router, route: ActivatedRoute, private _acordoService: AcordoService, private _devedor: DevedorService,
        private _emailService: EmailService, private _logSistema: LogSistemaService) {
        super(route, _acordoService);                
       this.getDividas();
    }   

    obterDadosBoletoEmailRequest(boletoid: number, devedorid: number){
        let dados = {
            boletoId: boletoid,
            devedorId: devedorid,
            email:""
        };

        return dados;
    }    
    
    postEmailSegundaViaBoleto(boletoid: number, devedorid: number) {       
        this._emailService.postBoletoEmailPortal(this.obterDadosBoletoEmailRequest(boletoid,devedorid)).subscribe(result => {                     
            this._notificationsService.Sucesso("Sucesso", "E-mail enviado com sucesso"); 
        });       
    }      

    getBoleto(url) {
        location.href = url;         
        this.gravaLog("downloadBoleto", this._logSistema, this.boletoId);
    };    

    verificaCadastroCompleto() {          
        this._currentUser.validacaoDados = true;
        localStorage.setItem('currentUserCobranca', JSON.stringify(this._currentUser));        
    }
    
    CopiadoCodigoBarras() {
        this._notificationsService.Sucesso("Código de Barras", "Copiado para área de transferência."); 
        this.gravaLog("copiarCodigoBarras", this._logSistema, this.boletoId);
    }

    getDividas() {
        this._loading.carregar();
        this.subDividas = this._devedor.getDividasPortal().subscribe(result => {
            this._loading.fecharTodos();
            this.dividas = result;              
            this.showForm = true;                      
            if (result.length > 0 && result[0].acordoDivida != null) this.boletoId = result[0].acordoDivida.boletoId;
            let numero = 1;                   
            this.dividas.forEach(element => {
                element.numeroDivida = numero;
                element.parcelas = this.ObterParcelas(element);
                numero++;
            });   
        });
    }

    ObterParcelas(divida) {        
        let parcelas = [];
        let parcelaSelecionada =  1;  
        divida.quantidadeParcelasSelecionada = parcelaSelecionada;

        for (let index = 1; index <= divida.numeroMaximoParcela; index++) {
            parcelas.push({ index: index, checked: index == parcelaSelecionada });
        }  
        return parcelas;
    }

    ngOnDestroy() {        
        if (this.subDevedor) this.subDevedor.unsubscribe();
        if (this.subDividas) this.subDividas.unsubscribe();        
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/portal/portal.component.ts